import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useSpring, animated, config } from "react-spring";

import "./AdminMenuEntry.css";
import { Icon } from "../../Icon/Icon";
import Tooltip from "react-tooltip-lite";

export const AdminMenuEntry = ({
  label,
  icon,
  activeIcon,
  iconWidth = 20,
  iconHeight = 20,
  path,
  expanded,
  forUsers = false,
}) => {
  const animationProps = useSpring({
    opacity: expanded ? 1 : 0,
    config: config.stiff,
  });
  const { pathname } = useLocation();
  const active = pathname.includes(path);

  const iconStyles = active
    ? "AdminMenuEntry__icon AdminMenuEntry__icon--active"
    : "AdminMenuEntry__icon";

  const labelStyles = active
    ? "AdminMenuEntry__label AdminMenuEntry__label--active"
    : "AdminMenuEntry__label";

  return (
    <Link to={forUsers ? path : `/admin/${path}`}>
      {!expanded && (
        <Tooltip
          useHover={true}
          content={<div className="AdminMenuEntry__hover-label">{label}</div>}
          direction="right-end"
          arrow={false}
          zIndex={2000}
          distance={-20}
        >
          <div className="AdminMenuEntry">
            <div className={iconStyles}>
              <Icon
                name={active ? activeIcon : icon}
                width={iconWidth}
                height={iconHeight}
              />
            </div>
          </div>
        </Tooltip>
      )}
      {expanded && (
        <div className="AdminMenuEntry">
          <div className={iconStyles}>
            <Icon
              name={active ? activeIcon : icon}
              width={iconWidth}
              height={iconHeight}
            />
          </div>

          <animated.div className={labelStyles} style={animationProps}>
            {label}
          </animated.div>
        </div>
      )}
    </Link>
  );
};
